import { appendToQueryString } from '@cotyorg/ccx-utils/js/helpers/url';

export default ({
  searchURL,
  value,
  locale,
}) => {
  const queryParams = {
    locale,
    query: encodeURI(`{"title":{"$regex":"${value}","$options":"i"}}\
&include=product_subcategory&include=product_subcategory.category`),
  };

  return appendToQueryString(searchURL, queryParams);
};
